/* Syrok — comparsa progressiva di sezioni, titoli e schede.

   Le regole di partenza in CSS (opacity 0) sono legate alla classe
   "syrok-anim" che mette questo script: se il JS non parte, o se
   l'utente ha chiesto meno movimento, la pagina resta semplicemente
   visibile invece di restare bianca. */
(function () {
  var radice = document.documentElement;

  var senzaMovimento =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (senzaMovimento || !('IntersectionObserver' in window)) return;

  radice.classList.add('syrok-anim');

  var sezioni = document.querySelectorAll('.syrok-section, .syrok-editorial');
  if (!sezioni.length) {
    radice.classList.remove('syrok-anim');
    return;
  }

  var haFunzionato = false;

  var osservatore = new IntersectionObserver(
    function (voci) {
      voci.forEach(function (voce) {
        if (voce.isIntersecting) {
          haFunzionato = true;
          voce.target.classList.add('is-in');
          osservatore.unobserve(voce.target);
        }
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.04 }
  );

  for (var i = 0; i < sezioni.length; i++) osservatore.observe(sezioni[i]);

  /* Rete di sicurezza: solo se l'osservatore non è MAI scattato.
     Mostrare tutto a prescindere annullerebbe l'effetto, perché
     arrivando in fondo le sezioni sarebbero già entrate. */
  window.setTimeout(function () {
    if (haFunzionato) return;
    for (var j = 0; j < sezioni.length; j++) sezioni[j].classList.add('is-in');
  }, 2500);
})();

/* Pagina prodotto Syrok — galleria accessibile e barra acquisto mobile.
   Il form resta quello nativo Flow: la barra inoltra il click al pulsante
   originale e non duplica variant ID, form o logica carrello. */
(function () {
  function initSyrokProduct() {
    var galleryButtons = document.querySelectorAll('[data-syrok-gallery-target]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setActiveGalleryButton(targetId) {
      for (var buttonIndex = 0; buttonIndex < galleryButtons.length; buttonIndex++) {
        var active = galleryButtons[buttonIndex].getAttribute('data-syrok-gallery-target') === targetId;
        galleryButtons[buttonIndex].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    for (var i = 0; i < galleryButtons.length; i++) {
      if (galleryButtons[i].dataset.syrokReady === 'true') continue;
      galleryButtons[i].dataset.syrokReady = 'true';
      galleryButtons[i].addEventListener('click', function () {
        var targetId = this.getAttribute('data-syrok-gallery-target');
        var target = document.getElementById(targetId);
        var track = target && target.closest('.syrok-product-gallery__track');
        if (!target || !track) return;
        setActiveGalleryButton(targetId);
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    var galleryTracks = document.querySelectorAll('.syrok-product-gallery__track');
    for (var trackIndex = 0; trackIndex < galleryTracks.length; trackIndex++) {
      (function (track) {
        var scrollFrame = null;
        track.addEventListener('scroll', function () {
          if (scrollFrame) cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(function () {
            var slides = track.querySelectorAll('.syrok-product-gallery__slide');
            var closest = null;
            var distance = Infinity;
            for (var slideIndex = 0; slideIndex < slides.length; slideIndex++) {
              var nextDistance = Math.abs(slides[slideIndex].offsetLeft - track.scrollLeft);
              if (nextDistance < distance) {
                closest = slides[slideIndex];
                distance = nextDistance;
              }
            }
            if (closest) setActiveGalleryButton(closest.id);
          });
        }, { passive: true });
      })(galleryTracks[trackIndex]);
    }

    var bar = document.querySelector('[data-syrok-mobile-buybar]');
    if (!bar || bar.dataset.syrokReady === 'true' || !('IntersectionObserver' in window)) return;
    bar.dataset.syrokReady = 'true';

    var barButton = bar.querySelector('[data-syrok-mobile-buybar-button]');
    var barPrice = bar.querySelector('[data-syrok-mobile-buybar-price]');
    var footer = document.querySelector('footer');
    var observedPrimary = null;
    var primaryPassed = false;
    var footerVisible = false;

    function currentPrimary() {
      return document.querySelector('.product--add-to-cart-button');
    }

    function updateBarVisibility() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      bar.hidden = !mobile || !primaryPassed || footerVisible;
    }

    function syncBar() {
      var primary = currentPrimary();
      var price = document.querySelector('.product-price-group .money');
      if (price && barPrice) barPrice.textContent = price.textContent.trim();
      if (!primary || !barButton) return;
      /* Il bottone di Atlas si disabilita mentre aggiunge al carrello e tiene
         dentro tutti i suoi stati come testo nascosto: leggerlo dava prima
         "Esaurito" a ogni clic, poi "Add to cart Added Loading...".
         La disponibilita' vera arriva dal Liquid e non cambia mentre si clicca. */
      var disponibile = bar.dataset.syrokAvailable !== 'false';
      barButton.disabled = !disponibile;
      barButton.textContent = disponibile ? 'Aggiungi al carrello' : 'Esaurito';
    }

    var primaryObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      primaryPassed = entry ? !entry.isIntersecting && entry.boundingClientRect.bottom <= 0 : false;
      updateBarVisibility();
    }, { threshold: 0.01 });

    function bindPrimary() {
      var primary = currentPrimary();
      if (primary === observedPrimary) return;
      if (observedPrimary) primaryObserver.unobserve(observedPrimary);
      observedPrimary = primary;
      if (observedPrimary) primaryObserver.observe(observedPrimary);
      syncBar();
    }

    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0] ? entries[0].isIntersecting : false;
        updateBarVisibility();
      }, { threshold: 0.01 }).observe(footer);
    }

    if (barButton) {
      barButton.addEventListener('click', function () {
        var primary = currentPrimary();
        if (primary && !primary.disabled) primary.click();
      });
    }

    var productInformation = document.querySelector('product-information');
    if (productInformation && 'MutationObserver' in window) {
      new MutationObserver(function () {
        bindPrimary();
        syncBar();
      }).observe(productInformation, { childList: true, subtree: true, attributes: true, characterData: true });
    }

    window.addEventListener('resize', updateBarVisibility);
    bindPrimary();
    updateBarVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSyrokProduct);
  } else {
    initSyrokProduct();
  }
})();

/* Conto alla rovescia della landing.
   Se la data non c'e' o e' gia' passata il blocco sparisce invece di
   mostrare numeri negativi: meglio niente che un contatore rotto. */
(function () {
  var box = document.querySelector('[data-syrok-conto]');
  if (!box) return;

  var quando = Date.parse(box.dataset.apertura);
  if (isNaN(quando)) { box.hidden = true; return; }

  var giorni = box.querySelector('[data-giorni]');
  var ore = box.querySelector('[data-ore]');
  var minuti = box.querySelector('[data-minuti]');
  var secondi = box.querySelector('[data-secondi]');

  function due(n) { return n < 10 ? '0' + n : String(n); }

  function aggiorna() {
    var resta = quando - Date.now();
    if (resta <= 0) { box.hidden = true; return; }
    var s = Math.floor(resta / 1000);
    giorni.textContent = Math.floor(s / 86400);
    ore.textContent = due(Math.floor(s % 86400 / 3600));
    minuti.textContent = due(Math.floor(s % 3600 / 60));
    secondi.textContent = due(s % 60);
  }

  aggiorna();
  setInterval(aggiorna, 1000);
})();


/* Frecce della giostra: servono solo dove le voci non ci stanno tutte. */
(function () {
  var g = document.querySelector('[data-syrok-giostra]');
  if (!g) return;
  var pista = g.querySelector('[data-pista]');
  var prec = g.querySelector('[data-giostra-prec]');
  var succ = g.querySelector('[data-giostra-succ]');
  if (!pista || !prec || !succ) return;

  function passo() {
    var v = pista.querySelector('.syrok-giostra__voce');
    return v ? v.getBoundingClientRect().width + 16 : pista.clientWidth * 0.7;
  }
  prec.addEventListener('click', function () { pista.scrollBy({ left: -passo(), behavior: 'smooth' }); });
  succ.addEventListener('click', function () { pista.scrollBy({ left: passo(), behavior: 'smooth' }); });
})();
